import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/pages.services";
import * as basicUserApi from "../../../services/basic.service";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_50, MENU_LOCATION, showFilterList } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const BasicUserEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("User"), url: "/admin/user-management/basic-user/list/1" },
    { title: t("btn_edit"), url: "" },
  ];
  const { id } = useParams();
  const isEdit = !!id;
  useEffect(() => {
    basicUserApi
      .Details(params.id)
      .then((data) => {
        console.log(`>>>data>>`, data);

        setShowDefault(data && data?.data ? data.data : []);
        console.log("data--->", data.data);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        initialValues={{
          firstName: showdefault && showdefault.firstName ? showdefault.firstName : "",
          lastName: showdefault && showdefault.lastName ? showdefault.lastName : "",
          status:
            showdefault && showdefault.status,
          email:
            showdefault && showdefault.email ? showdefault.email : "",
          phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
        }}
        validate={(values) => {
          const error = {};

          // Trim all necessary string fields first
          const firstName = values.firstName?.trim() || "";
          const lastName = values.lastName?.trim() || "";
          const phone_number = values.phone_number?.trim() || "";

          // Title Validation
          if (firstName && firstName.length > INPUT_LENGTH_50)
            error.firstName = t("validation_err_reached_maximum_length");

          // Slug Validation
          if (lastName && lastName.length > INPUT_LENGTH_50)
            error.lastName = t("validation_err_reached_maximum_length");

          // Status Validation
          if (!values.status) error.status = t("validation_err_status_required");

          // Menu Location Validation
          // if (!values.email) error.email = t("label_email_error");
          if (!values.email) {
            error.email = t("label_email_error");
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            error.email = t("invalid_email"); // translation key bana lena
          }

          // Short Description Validation
          // if (!phone_number) error.phone_number = t("label_phone_error");

          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          const id = params.id;

          let formData = new FormData();
          formData.append("firstName", values.firstName.trim());
          formData.append("lastName", values.lastName.trim());
          formData.append("status", values.status);
          formData.append("email", values.email.trim());

          basicUserApi.Edit(formData, id)
            .then((response) => {
              setSubmitting(false);

              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });

                if (saveType !== "Save") {
                  navigate(`/admin/user-management/basic-user/list/1`);
                }

                globalLoader(false);
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
                globalLoader(false);
              }
            })
            .catch((error) => {
              globalLoader(false);
              Swal.fire({
                icon: "error",
                text: handleServerValidations(error),
                ...SWAL_SETTINGS,
              });
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">Basic Edit</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="firstName" className="text-left d-flex">
                            {t("label_first_name")}:
                          </label>
                          <input
                            name="firstName"
                            id="firstName"
                            type="text"
                            placeholder="Enter the first name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.firstName}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.firstName && touched.firstName && errors.firstName}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="lastName" className="text-left d-flex">
                            {t("label_last_name")}:
                          </label>
                          <input
                            name="lastName"
                            id="lastName"
                            type="text"
                            placeholder="Enter the last name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.lastName}
                            // disabled={"disabled"}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.lastName && touched.lastName && errors.lastName}
                          </span>
                        </div>

                        <div className="col-md-6 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >

                              {(showFilterList).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>


                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="email" className="text-left d-flex">
                            {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="email"
                            id="email"
                            type="text"
                            placeholder="Enter the email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            
                            value={values.email}
                            disabled={"disabled"}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.email && touched.email && errors.email}
                          </span>
                        </div>

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}


                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default BasicUserEdit;